import React, { useState } from 'react';

import {
  Alert,
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Link,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';

import { SnackbarCloseReason } from '@mui/material/Snackbar';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IosShareIcon from '@mui/icons-material/IosShare';

import { ResultType } from './results';

const ShareLinks = ({ results }: { results: ResultType[] }) => {
  const url = decodeURIComponent(window.location.href);
  // console.log('url', url);

  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [openSnackBar, setOpenSnackBar] = useState<boolean>(false);
  const [videoLinks, setVideoLinks] = useState<string>('');

  const get_video_link = () => {
    // console.log('results', results);
    let video_links = results.map((r: ResultType, index) => {
      return `${index + 1}: ` + r['標題'].trim() + ' ' + r['上傳YOUTUBE'];
    });
    let video_links_string = video_links.join('\n');
    // console.log('video links', video_links_string);
    setOpenDialog(true);
    setVideoLinks(video_links_string);
  };

  const handleSnackClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackBar(false);
  };

  const copy_to_clipboard = (text: string) => {
    const copy = async () => await navigator.clipboard.writeText(text);
    try {
      copy();
      setOpenSnackBar(true);
    } catch (e) { console.log('Copy link failed') }
  }

  const copy_btn = (text: string) => (
    <IconButton onClick={() => copy_to_clipboard(text)}>
      <ContentCopyIcon sx={{ width: 18, height: 18 }} />
    </IconButton>
  )

  return (
    <>
      <IconButton
        color='primary'
        size='small'
        onClick={() => get_video_link()}
      >
        <IosShareIcon />
      </IconButton>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth='md'
        fullWidth
      >
        <DialogContent>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 0.5 }}>
            <Typography variant='h5' textAlign='center' sx={{ ml: 4, mr: 0.3 }}>分享網址</Typography>
            {copy_btn(url)}
          </Box>
          <Link sx={{ cursor: 'pointer' }} onClick={() => { copy_to_clipboard(url) }}>
            <Typography variant='body1' textAlign='center'>{url}</Typography>
          </Link>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 0.5, mt: 2 }}>
            <Typography variant='h5' textAlign='center' sx={{ ml: 4, mr: 0.3 }}>影片連結</Typography>
            {copy_btn(videoLinks)}
          </Box>
          <TextField
            multiline
            rows={10}
            fullWidth
            value={videoLinks}
          />
        </DialogContent>
      </Dialog >
      <Snackbar open={openSnackBar} autoHideDuration={6000}
        onClose={handleSnackClose}
      >
        <Alert
          onClose={handleSnackClose}
          severity='success'
          variant='filled'
          sx={{ width: '100%' }}
        >
          以複製到剪貼簿
        </Alert>
      </Snackbar>
    </>
  )
}

export default ShareLinks;